import cardService from 'api/card';

const handleError = (error) => {
  let result = error;

  if (typeof error.json === 'function') {
    error
      .json()
      .then((errorJson) => {
        result = errorJson;
      })
      .catch(() => {
        result = error;
      });
  } else {
    result = error;
  }

  return result;
};

export default {
  getCards: () => (dispatch) => new Promise((resolve, reject) => {
    dispatch({ type: 'GET_CARDS' });
    cardService
      .getCards()
      .then((response) => {
        response.json().then((responseJson) => {
          dispatch({ type: 'GET_CARDS_SUCCESS', data: responseJson });
          resolve(responseJson);
        });
      })
      .catch((error) => {
        const errorInfo = handleError(error);

        dispatch({ type: 'GET_CARDS_FAIL', error: errorInfo });
        reject(errorInfo);
      });
  }),
  setCard: (card) => (dispatch) => {
    dispatch({ type: 'SET_CARD', card });
  },
};
